// LIST
export const FETCH_ENQUIRIES = "app/Enquiries/FETCH_ENQUIRIES";
export const FETCH_ENQUIRIES_SUCCESS = "app/Enquiries/FETCH_ENQUIRIES_SUCCESS";
export const FETCH_ENQUIRIES_FAILURE = "app/Enquiries/FETCH_ENQUIRIES_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/Enquiries/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Enquiries/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Enquiries/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_ENQUIRY = "app/Enquiries/ADD_ENQUIRY";
export const ADD_ENQUIRY_SUCCESS = "app/Enquiries/ADD_ENQUIRY_SUCCESS";
export const ADD_ENQUIRY_FAILURE = "app/Enquiries/ADD_ENQUIRY_FAILURE";
// EDIT
export const EDIT_ENQUIRY = "app/Enquiries/EDIT_ENQUIRY";
export const EDIT_ENQUIRY_SUCCESS = "app/Enquiries/EDIT_ENQUIRY_SUCCESS";
export const EDIT_ENQUIRY_FAILURE = "app/Enquiries/EDIT_ENQUIRY_FAILURE";
// DELETE
export const DELETE_ENQUIRY = "app/Enquiries/DELETE_ENQUIRY";
export const DELETE_ENQUIRY_SUCCESS = "app/Enquiries/DELETE_ENQUIRY_SUCCESS";
export const DELETE_ENQUIRY_FAILURE = "app/Enquiries/DELETE_ENQUIRY_FAILURE";
// DELETE NOTE
export const DELETE_ENQUIRY_NOTE = "app/Enquiries/DELETE_ENQUIRY_NOTE";
export const DELETE_ENQUIRY_NOTE_SUCCESS =
  "app/Enquiries/DELETE_ENQUIRY_NOTE_SUCCESS";
export const DELETE_ENQUIRY_NOTE_FAILURE =
  "app/Enquiries/DELETE_ENQUIRY_NOTE_FAILURE";
// DELETE ENQUIRY NOTE
export const DELETE_ENQUIRY_REMINDER_NOTE =
  "app/Enquiries/DELETE_ENQUIRY_REMINDER_NOTE";
export const DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS =
  "app/Enquiries/DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS";
export const DELETE_ENQUIRY_REMINDER_NOTE_FAILURE =
  "app/Enquiries/DELETE_ENQUIRY_REMINDER_NOTE_FAILURE";
//
export const OPEN_NOTE_ADD_MODAL = "app/Enquiries/OPEN_NOTE_ADD_MODAL";
export const CLOSE_NOTE_ADD_MODAL = "app/Enquiries/CLOSE_NOTE_ADD_MODAL";
//
export const OPEN_REMINDER_ADD_MODAL = "app/Enquiries/OPEN_REMINDER_ADD_MODAL";
export const CLOSE_REMINDER_ADD_MODAL =
  "app/Enquiries/CLOSE_REMINDER_ADD_MODAL";

export const TOGGLE_EVENT_MODAL = "app/Enquiries/TOGGLE_EVENT_MODAL";
export const TOGGLE_ADDRESS_MODAL = "app/Enquiries/TOGGLE_ADDRESS_MODAL";
export const TOGGLE_ATTORNEY_MODAL = "app/Enquiries/TOGGLE_ATTORNEY_MODAL";
export const TOGGLE_ASSIGN_MODAL = "app/Enquiries/TOGGLE_ASSIGN_MODAL";

export const TOGGLE_SCHEDULE_MODAL = "app/Enquiries/TOGGLE_SCHEDULE_MODAL";
export const TOGGLE_OUTCOME_MODAL = "app/Enquiries/TOGGLE_OUTCOME_MODAL";
export const TOGGLE_REMINDER_MODAL = "app/Enquiries/TOGGLE_REMINDER_MODAL";
export const TOGGLE_CLOSE_MODAL = "app/Enquiries/TOGGLE_CLOSE_MODAL";
export const TOGGLE_DOC_MODAL = "app/Enquiries/TOGGLE_DOC_MODAL";
export const TOGGLE_OTHER_MODAL = "app/Enquiries/TOGGLE_OTHER_MODAL";
export const TOGGLE_EXIST_MODAL = "app/Enquiries/TOGGLE_EXIST_MODAL";

// ADD
export const ADD_NOTE = "app/Enquiries/ADD_NOTE";
export const ADD_NOTE_SUCCESS = "app/Enquiries/ADD_NOTE_SUCCESS";
export const ADD_NOTE_FAILURE = "app/Enquiries/ADD_NOTE_FAILURE";

// LIST NOTES
export const GET_NOTES = "app/Enquiries/GET_NOTES";
export const GET_NOTES_SUCCESS = "app/Enquiries/GET_NOTES_SUCCESS";
export const GET_NOTES_FAILURE = "app/Enquiries/GET_NOTES_FAILURE";

// ADD ENQUIRY REMINDER
export const ADD_REMINDER = "app/Enquiries/ADD_REMINDER";
export const ADD_REMINDER_SUCCESS = "app/Enquiries/ADD_REMINDER_SUCCESS";
export const ADD_REMINDER_FAILURE = "app/Enquiries/ADD_REMINDER_FAILURE";

// LIST ENQUIRY NOTES
export const GET_REMINDERS = "app/Enquiries/GET_REMINDERS";
export const GET_REMINDERS_SUCCESS = "app/Enquiries/GET_REMINDERS_SUCCESS";
export const GET_REMINDERS_FAILURE = "app/Enquiries/GET_REMINDERS_FAILURE";

export const GET_TIMELINE = "app/Enquiries/GET_TIMELINE";
export const GET_TIMELINE_SUCCESS = "app/Enquiries/GET_TIMELINE_SUCCESS";
export const GET_TIMELINE_FAILURE = "app/Enquiries/GET_TIMELINE_FAILURE";

// ADD EVENT
export const ADD_EVENT = "app/Enquiries/ADD_EVENT";
export const ADD_EVENT_SUCCESS = "app/Enquiries/ADD_EVENT_SUCCESS";
export const ADD_EVENT_FAILURE = "app/Enquiries/ADD_EVENT_FAILURE";

export const GET_STATS = "app/Enquiries/GET_STATS";
export const GET_STATS_SUCCESS = "app/Enquiries/GET_STATS_SUCCESS";
export const GET_STATS_FAILURE = "app/Enquiries/GET_STATS_FAILURE";

export const SAVE_DOCS = "app/Enquiries/SAVE_DOCS";
export const SAVE_DOCS_SUCCESS = "app/Enquiries/SAVE_DOCS_SUCCESS";
export const SAVE_DOCS_FAILURE = "app/Enquiries/SAVE_DOCS_FAILURE";

export const SAVE_OUTCOME = "app/Enquiries/SAVE_OUTCOME";
export const SAVE_OUTCOME_SUCCESS = "app/Enquiries/SAVE_OUTCOME_SUCCESS";
export const SAVE_OUTCOME_FAILURE = "app/Enquiries/SAVE_OUTCOME_FAILURE";

export const SAVE_CLOSE = "app/Enquiries/SAVE_CLOSE";
export const SAVE_CLOSE_SUCCESS = "app/Enquiries/SAVE_CLOSE_SUCCESS";
export const SAVE_CLOSE_FAILURE = "app/Enquiries/SAVE_CLOSE_FAILURE";

export const SET_VIEW = "app/Enquiries/SET_VIEW";

export const SEARCH_EMAIL = "app/Enquiries/SEARCH_EMAIL";
export const SEARCH_EMAIL_SUCCESS = "app/Enquiries/SEARCH_EMAIL_SUCCESS";
export const SEARCH_EMAIL_FAILURE = "app/Enquiries/SEARCH_EMAIL_FAILURE";

export const SEARCH_CONTACT = "app/Enquiries/SEARCH_CONTACT";
export const SEARCH_CONTACT_SUCCESS = "app/Enquiries/SEARCH_CONTACT_SUCCESS";
export const SEARCH_CONTACT_FAILURE = "app/Enquiries/SEARCH_CONTACT_FAILURE";

export const EDIT_OUTCOME = "app/Enquiries/EDIT_OUTCOME";
export const EDIT_OUTCOME_SUCCESS = "app/Enquiries/EDIT_OUTCOME_SUCCESS";
export const EDIT_OUTCOME_FAILURE = "app/Enquiries/EDIT_OUTCOME_FAILURE";

export const GET_ENQ_CHART = "app/Enquiries/GET_ENQ_CHART";
export const GET_ENQ_CHART_SUCCESS = "app/Enquiries/GET_ENQ_CHART_SUCCESS";
export const GET_ENQ_CHART_FAILURE = "app/Enquiries/GET_ENQ_CHART_FAILURE";

export const GET_CL_REPORT = "app/Enquiries/GET_CL_REPORT";
export const GET_CL_REPORT_SUCCESS = "app/Enquiries/GET_CL_REPORT_SUCCESS";
export const GET_CL_REPORT_FAILURE = "app/Enquiries/GET_CL_REPORT_FAILURE";

export const GET_AQ_REPORT = "app/Enquiries/GET_AQ_REPORT";
export const GET_AQ_REPORT_SUCCESS = "app/Enquiries/GET_AQ_REPORT_SUCCESS";
export const GET_AQ_REPORT_FAILURE = "app/Enquiries/GET_AQ_REPORT_FAILURE";

export const GET_REF_REPORT = "app/Enquiries/GET_REF_REPORT";
export const GET_REF_REPORT_SUCCESS = "app/Enquiries/GET_REF_REPORT_SUCCESS";
export const GET_REF_REPORT_FAILURE = "app/Enquiries/GET_REF_REPORT_FAILURE";
export const SET_REPORT = "app/Enquiries/SET_REPORT";

export const GET_TYPE_REPORT = "app/Enquiries/GET_TYPE_REPORT";
export const GET_TYPE_REPORT_SUCCESS = "app/Enquiries/GET_TYPE_REPORT_SUCCESS";
export const GET_TYPE_REPORT_FAILURE = "app/Enquiries/GET_TYPE_REPORT_FAILURE";

export const GET_MAP_REPORT = "app/Enquiries/GET_MAP_REPORT";
export const GET_MAP_REPORT_SUCCESS = "app/Enquiries/GET_MAP_REPORT_SUCCESS";
export const GET_MAP_REPORT_FAILURE = "app/Enquiries/GET_MAP_REPORT_FAILURE";

export const GET_MY_TASK = "app/Enquiries/GET_MY_TASK";
export const GET_MY_TASK_SUCCESS = "app/Enquiries/GET_MY_TASK_SUCCESS";
export const GET_MY_TASK_FAILURE = "app/Enquiries/GET_MY_TASK_FAILURE";

export const SEARCH_USER = "app/Enquiries/SEARCH_USER";
export const SEARCH_USER_SUCCESS = "app/Enquiries/SEARCH_USER_SUCCESS";
export const SEARCH_USER_FAILURE = "app/Enquiries/SEARCH_USER_FAILURE";

export const GET_COUNTY = "app/Enquiries/GET_COUNTY";
export const GET_COUNTY_SUCCESS = "app/Enquiries/GET_COUNTY_SUCCESS";
export const GET_COUNTY_FAILURE = "app/Enquiries/GET_COUNTY_FAILURE";

export const UPDATE_DONE = "app/Enquiries/UPDATE_DONE";
export const UPDATE_DONE_SUCCESS = "app/Enquiries/UPDATE_DONE_SUCCESS";
export const UPDATE_DONE_FAILURE = "app/Enquiries/UPDATE_DONE_FAILURE";

export const SET_DIGITAL_DATA = "app/Enquiries/SET_DIGITAL_DATA";
export const SET_RECOMM_DATA = "app/Enquiries/SET_RECOMM_DATA";
export const SET_LOCAL_DATA = "app/Enquiries/SET_LOCAL_DATA";
export const SET_ADVERT_DATA = "app/Enquiries/SET_ADVERT_DATA";
